import Vue from 'vue'
import VueRouter from 'vue-router'
import goTo from 'vuetify/es5/services/goto'
import Missing from '../views/404.vue'
import MinimalAgency from '../views/all-home-version/MinimalAgency.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        component: MinimalAgency,
        meta: {
            title: 'Rainfo || Creative Minimal Portfolio'
        }
    },
    {
        path: '/kezdolap',
        component: MinimalAgency,
        meta: {
            title: 'Rainfo || Creative Minimal Portfolio'
        }
    },
    {
        path: '/main-demo',
        name: 'MainDemo',
        meta: {
            title: 'Rainfo || Main Demo Portfolio'
        },
        component: () =>
            import ('../views/all-home-version/MainDemo.vue')
    },
    {
        path: '/freelancer',
        name: 'Freelancer',
        meta: {
            title: 'Rainfo || Freelancer Portfolio'
        },
        component: () =>
            import ('../views/all-home-version/Freelancer.vue')
    },
    {
        path: '/agency',
        name: 'Agency',
        meta: {
            title: 'Rainfo || Agency Portfolio'
        },
        component: () =>
            import ('../views/all-home-version/Agency.vue')
    },
    {
        path: '/minimal-agency',
        name: 'MinimalAgency',
        meta: {
            title: 'Rainfo || Minimal Agency Portfolio'
        },
        component: () =>
            import ('../views/all-home-version/MinimalAgency.vue')
    },
    {
        path: '/creative-portfolio',
        name: 'CreativePortfolio',
        meta: {
            title: 'Rainfo || Creative Portfolio'
        },
        component: () =>
            import ('../views/all-home-version/CreativePortfolio.vue')
    },
    {
        path: '/designer-portfolio',
        name: 'DesignerPortfolio',
        meta: {
            title: 'Rainfo || Designer Portfolio'
        },

        component: () =>
            import ('../views/all-home-version/DesignerPortfolio.vue')
    },
    {
        path: '/vertical-portfolio',
        name: 'VerticalPortfolio',
        meta: {
            title: 'Rainfo || Vertical Portfolio'
        },
        component: () =>
            import ('../views/all-home-version/VerticalPortfolio.vue')
    },
    {
        path: '/multiscroll-portfolio',
        name: 'MultiScrollPortfolio',
        meta: {
            title: 'Rainfo || Multiscroll Portfolio'
        },
        component: () =>
            import ('../views/all-home-version/MultiScrollPortfolio.vue')
    },
    {
        path: '/parallax-home',
        name: 'ParallaxHome',
        meta: {
            title: 'Rainfo || Parallax Portfolio'
        },
        component: () =>
            import ('../views/all-home-version/ParallaxHome.vue')
    },
    {
        path: '/portfolio-details',
        name: 'PortfolioDetails',
        meta: {
            title: 'Rainfo || Portfolio Details'
        },
        component: () =>
            import ('../views/PortfolioDetails.vue')
    },
    {
        path: '/service-details',
        name: 'ServiceDetails',
        meta: {
            title: 'Rainfo || Service Details'
        },
        component: () =>
            import ('../views/ServiceDetails.vue')
    },
    {
        path: '/blog-details',
        name: 'BlogDetails',
        meta: {
            title: 'Rainfo || Blog Details'
        },
        component: () =>
            import ('../views/BlogDetails.vue')
    },
    {
        path: '/contact',
        name: 'Contact',
        meta: {
            title: 'Rainfo || Contact'
        },
        component: () =>
            import ('../views/Contact.vue')
    },
    {
        path: '/about-us',
        name: 'AboutUs',
        meta: {
            title: 'Rainfo || AboutUs'
        },
        component: () =>
            import ('../views/AboutUs.vue')
    },
    {
        path: '/awards',
        name: 'Awards',
        meta: {
            title: 'Rainfo || Awards'
        },
        component: () =>
            import ('../views/Awards.vue')
    },
    {
        path: '/blog',
        name: 'Blog',
        meta: {
            title: 'Rainfo || Blog'
        },
        component: () =>
            import ('../views/Blog.vue')
    },
    {
        path: '/portfolio',
        name: 'Portfolio',
        meta: {
            title: 'Rainfo || Portfolio'
        },
        component: () =>
            import ('../views/Portfolio.vue')
    },
    {
        path: '/service',
        name: 'Service',
        meta: {
            title: 'Rainfo || Service'
        },
        component: () =>
            import ('../views/Service.vue')
    },
    {
        path: '/tarsashazak',
        name: 'Tarsashazak',
        meta: {
            title: 'Rainfo || Service'
        },
        component: () =>
            import ('../views/szolgaltatas/Tarsashazak.vue')
    },
    {
        path: '/melyepites',
        name: 'Melyepites',
        meta: {
            title: 'Rainfo || Service'
        },
        component: () =>
            import ('../views/szolgaltatas/Melyepites.vue')
    },
    {
        path: '/csarnokepites',
        name: 'Csarnokepites',
        meta: {
            title: 'Rainfo || Service'
        },
        component: () =>
            import ('../views/szolgaltatas/Csarnokepites.vue')
    },
    {
        path: '/lakatos-munkak',
        name: 'LakatosMunkak',
        meta: {
            title: 'Rainfo || Service'
        },
        component: () =>
            import ('../views/szolgaltatas/LakatosMunkak.vue')
    },
    {
        path: '/belso-iroda-atalakitasok',
        name: 'BelsoIrodaAtalakitasok',
        meta: {
            title: 'Rainfo || Service'
        },
        component: () =>
            import ('../views/szolgaltatas/BelsoIrodaAtalakitasok.vue')
    },
    {
        path: '/butorasztalos-munkak',
        name: 'ButorasztalosMunkak',
        meta: {
            title: 'Rainfo || Service'
        },
        component: () =>
            import ('../views/szolgaltatas/ButorasztalosMunkak.vue')
    },
    {
        path: '/nyilaszarok-gyartasa-csereje',
        name: 'NyilaszarokGyartasa',
        meta: {
            title: 'Rainfo || Service'
        },
        component: () =>
            import ('../views/szolgaltatas/NyilaszarokGyartasa.vue')
    },
    {
        path: '/gipszkarton-allmennyezet',
        name: 'GipszkartonAllmennyezet',
        meta: {
            title: 'Rainfo || Service'
        },
        component: () =>
            import ('../views/szolgaltatas/GipszkartonAllmennyezet.vue')
    },
    {
        path: '/gyenge-es-erosaramu-szakipari-munkak',
        name: 'GipszkartonAllmennyezet',
        meta: {
            title: 'Rainfo || Service'
        },
        component: () =>
            import ('../views/szolgaltatas/GyengeEsErosAram.vue')
    },
    {
        path: '/okosotthon',
        name: 'Okosotthon',
        meta: {
            title: 'Rainfo || Service'
        },
        component: () =>
            import ('../views/szolgaltatas/Okosotthon.vue')
    },
    {
        path: '/bontas',
        name: 'Bontas',
        meta: {
            title: 'Rainfo || Service'
        },
        component: () =>
            import ('../views/szolgaltatas/Bontas.vue')
    },
    {
        path: '/zold-felulet-epitese',
        name: 'ZoldFeluletEpitese',
        meta: {
            title: 'Rainfo || Service'
        },
        component: () =>
            import ('../views/szolgaltatas/ZoldFeluletEpitese.vue')
    },
    {
        path: '/palyazat',
        name: 'Palyazat',
        meta: {
            title: 'Rainfo || Service'
        },
        component: () =>
            import ('../views//Palyazat.vue')
    },
    {
        path: '*',
        component: Missing,
        meta: {
            title: 'Rainfo || 404'
        },
    }
]

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = 0

        if (to.hash) {
            scrollTo = to.hash
        } else if (savedPosition) {
            scrollTo = savedPosition.y
        }

        return goTo(scrollTo)
    },
})

router.beforeEach((to, from, next) => {
    document.title = "Global Építő Kft."
    next()
})


export default router